import { IPersonalInfoCMS, IProduct } from '@vfit/consumer/data-access';

export const organizeConfirmIdentityCard = (
  dataFromCms: IPersonalInfoCMS,
  product: IProduct | null
) => ({
  titleCms: dataFromCms?.personalinfo?.clientRecognition?.title || '',
  descriptionCms: dataFromCms?.personalinfo?.clientRecognition?.description || '',
  placeholderCms: dataFromCms?.personalinfo?.selectInput?.contactPlaceholder || '',
  ctaLabelCms: dataFromCms?.personalinfo?.clientRecognition?.codeNotAccessLabel || '',
  ctaUrl:
    dataFromCms?.personalinfo?.clientRecognition?.contactNotAccessUrl ||
    product?.urlClickToCallOtp ||
    '',
});

